"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = void 0;
const ValidUrlRule = require("../ValidUrlRule");
exports.builder = {
    isValidUrl: () => {
        const rule = { type: ValidUrlRule.NAME };
        const returnValue = {
            requireTld: (required = true) => {
                rule.require_tld = `${required}`;
                return returnValue;
            },
            requireHost: (required = true) => {
                rule.require_host = `${required}`;
                return returnValue;
            },
            requireProtocol: (required = false) => {
                rule.require_protocol = `${required}`;
                return returnValue;
            },
            build: () => rule,
        };
        return returnValue;
    },
};
//# sourceMappingURL=IsValidUrlBuilder.js.map